import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "../chat/chatData";
import Header from "../header/header";
import ChatBoxType2 from "../chat/chatType2";

import "./answer.css";

export default function Answer(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const { increaseMissionOnce } = useGame();

  const state = location.state || {};
  const { DateVal, missionKey, titImgClass, counting } = state;

  // console.log(state);

  const answerData = CHAT_DATA[DateVal];

  const chatRef = useRef(null);

  useEffect(() => {
    if (!counting || !missionKey) return;

    increaseMissionOnce(missionKey);
  }, [counting, missionKey, increaseMissionOnce]);

  return (
    <div id="content">
      <Header />

      <div className="content_box1 ans0001">
        <div className="box box_con con_box1 con_pd5 con_box_c">
          <div className={`mission_tit ${titImgClass} mt24`}></div>

          <ChatBoxType2
            dataWord={DateVal}
            DateVal={answerData}
            titImgclass={titImgClass}
            chatClass="chat_box6"
            ref={chatRef}
            onFinish={({ route }) => navigate(route)}
          />
        </div>
      </div>
    </div>
  );
}
